import { getAlias } from '../../utils/utils';

const formatter = ([{ photos }]) => {
  const images = photos.map(imageObject => imageObject.ppImage);
  const thumbnails = photos.map(imageObject => imageObject.ppThumb);

  return { images, thumbnails };
};

export const GalleryPages = {
  parcels: 'parcels',
  products: 'products',
  knowledge_base: 'knowledge_base',
};

export const GalleryProps = {
  [GalleryPages.parcels]: {
    url: 'office_parcels/images',
    idsKey: 'parcel_ids',
    galleryAliasExtractor: getAlias,
    formatter,
  },
  [GalleryPages.products]: {
    url: 'office_cases/images',
    idsKey: 'case_ids',
    galleryAliasExtractor: getAlias,
    formatter,
  },
  [GalleryPages.knowledge_base]: ({ instructionId, characteristicId }) => ({
    url: `office_knowledge_base/${instructionId}/characteristic/${characteristicId}/images`,
    idsKey: 'unnecessary',
    galleryAliasExtractor: getAlias,
    formatter,
  }),
};
